import { render, staticRenderFns } from "./AddMembersInChatModal.vue?vue&type=template&id=f3b9a7c6&"
import script from "./AddMembersInChatModal.vue?vue&type=script&lang=js&"
export * from "./AddMembersInChatModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMembersInChatModal.vue?vue&type=style&index=0&id=f3b9a7c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports